export default __webpack_public_path__ + "static/media/SUBDOM_Dashboard.3cb5fa90.svg";